/*
 * @Author: your name
 * @Date: 2022-03-02 22:09:09
 * @LastEditTime: 2022-03-09 15:54:24
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\personal\bindmobile\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "绑定手机号",
    login: false
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {
    /** 姓名 */
    Account = "forgetpwd.account",
    /** 头像 */
    Avatar = "example.avatar",
    /** 生日 */
    Birthday = "example.birthday",
    /** 年龄 */
    Age = "example.Age",
    /** 性别 */
    Gender = "example.gender",
    Gender_Male = "Male",
    Gender_Girl = "Girl",
    /** 介绍 */
    Introduce = "example.introduce",
    /** 创建时间 */
    CreateDate = "example.createDate",
}
export enum EnumGender {
    /** 男 */
    Male = 1,
    /** 女 */
    Girl = 2
}
export default {
    en: {
        [EnumLocaleLabel.Account]: 'Account',
        [EnumLocaleLabel.Avatar]: 'Avatar',
        [EnumLocaleLabel.Birthday]: 'Birthday',
        [EnumLocaleLabel.Age]: 'Age',
        [EnumLocaleLabel.Gender]: 'Gender',
        [EnumLocaleLabel.Gender_Male]: 'Male',
        [EnumLocaleLabel.Gender_Girl]: 'Girl',
        [EnumLocaleLabel.Introduce]: 'Introduce',
        [EnumLocaleLabel.CreateDate]: 'CreateDate',
    },
    zh: {
        [EnumLocaleLabel.Account]: '账号',
        [EnumLocaleLabel.Avatar]: '头像',
        [EnumLocaleLabel.Birthday]: '生日',
        [EnumLocaleLabel.Age]: '年龄',
        [EnumLocaleLabel.Gender]: '性别',
        [EnumLocaleLabel.Gender_Male]: '男',
        [EnumLocaleLabel.Gender_Girl]: '女',
        [EnumLocaleLabel.Introduce]: '简介',
        [EnumLocaleLabel.CreateDate]: '创建时间',
    }
}